import { subDays, startOfDay, endOfDay } from "date-fns";
import { USAGE_DEFINITION } from "@/misc/desktopCharts";
import getUsageData from "@/api/usageAndPerformance";
import { getEndOfValidDate } from "@/lib/utilFunctions";

const initModule = () => {
  return {
    selectedDateRange: null, // this should be initialized by usage page
    activeUsage: USAGE_DEFINITION[0].name,
    usageData: USAGE_DEFINITION.reduce((acc, cur) => {
      acc[cur.name] = {
        chartInfo: cur,
      };
      if (cur.disabled) {
        acc[cur.name].disabled = true;
      }
      return acc;
    }, {}),
  };
};

const state = initModule();
const getters = {
  activeUsage: (state) => {
    return state.activeUsage;
  },
  selectedDateRange: (state) => {
    return state.selectedDateRange;
  },

  usageByName: (state) => {
    return (usageName) => state.usageData[usageName] || null;
  },
  usageData: (state) => {
    return state.usageData;
  },
};

const actions = {
  initDateRange({ dispatch }) {
    const END_OF_VALID_DATE = getEndOfValidDate();
    dispatch("setDateRange", {
      startDate: startOfDay(subDays(END_OF_VALID_DATE, 30)),
      endDate: startOfDay(END_OF_VALID_DATE),
    });
  },
  setDateRange({ commit, dispatch }, payload) {
    commit("setDateRange", payload);
    dispatch("fetchAllUsage");
  },
  fetchAllUsage({ dispatch, state }) {
    if (!state.selectedDateRange) {
      return;
    }
    Object.keys(state.usageData).forEach((usageItem) => {
      if (!state.usageData[usageItem].disabled) {
        dispatch("fetchUsage", usageItem);
      }
    });
  },
  async fetchUsage({ commit, rootGetters, state }, usageItem) {
    const startDate = startOfDay(subDays(state.selectedDateRange.startDate, 1));
    const endDate = endOfDay(subDays(state.selectedDateRange.endDate, 1));
    const currentStore = rootGetters["user/getCurrentStore"];
    const filters = rootGetters["filters/getAllActiveFilters"];
    const showOnlyUniqueUsers = rootGetters["filters/getShowOnlyUniqueUsers"];
    commit("setLoadingStatus", {
      usageItem,
      loadingStatus: true,
    });
    try {
      let usageData = await getUsageData({
        name: usageItem,
        storeId: currentStore.store_id,
        startDate,
        endDate,
        filters,
        showOnlyUniqueUsers,
        page: "usage",
      });
      commit("setUsage", {
        usageItem,
        usageData,
      });
    } catch (e) {
      commit("setUsageError", {
        usageItem,
      });
    } finally {
      commit("setLoadingStatus", {
        usageItem,
        loadingStatus: false,
      });
    }
  },
};
const mutations = {
  resetModule(state) {
    const initValue = initModule();
    Object.keys(initValue).forEach((key) => {
      state[key] = initValue[key];
    });
  },
  setActiveUsage(state, usageName) {
    state.activeUsage = usageName;
  },
  setDateRange(state, payload) {
    state.selectedDateRange = {};
    state.selectedDateRange.startDate = payload.startDate;
    state.selectedDateRange.endDate = payload.endDate;
  },
  setLoadingStatus(state, payload) {
    let { usageItem, loadingStatus } = payload;
    state.usageData[usageItem] = {
      ...state.usageData[usageItem],
      isLoading: loadingStatus,
    };
  },
  setUsage(state, payload) {
    let { usageItem, usageData } = payload;
    state.usageData[usageItem] = {
      ...state.usageData[usageItem],
      ...usageData,
      isError: false,
    };
  },
  setUsageError(state, payload) {
    let { usageItem } = payload;
    state.usageData[usageItem] = {
      ...state.usageData[usageItem],
      isError: true,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
